module.exports = __webpack_public_path__ + "static/img/dinersclub.97cf293e.svg";